// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609240629/js/" + chunkId + "." + {"44":"8542b5c5","225":"d0421858","481":"3750f67a","486":"21e0cd85","770":"2ffbcc4d"}[chunkId] + ".0.06743752733674568.chunk.js";
};